import { Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { ProfileEditorWrapper } from '../common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SocialAccountsBox = function SocialAccountsBox(_ref) {
  var _children = _ref.children;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "SocialAccountsBox",
    "data-source-file": "social-accounts-box.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsxs(ProfileEditorWrapper, {
        children: [/*#__PURE__*/_jsx(Typography, {
          sx: {
            mb: 1
          },
          variant: "h2",
          children: t('Social accounts')
        }), /*#__PURE__*/_jsx(Typography, {
          sx: {
            mb: 3
          },
          variant: "body2",
          children: t('Connect to your social media accounts to complete social challenges.')
        }), _children]
      });
    }
  });
};